/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { List, ListItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import styles from '../../styles/footerStyle.js';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(styles);

export default function HomeFooter(props) {
  const classes = useStyles();
  const settings = useSelector(state => state.settingsdata.settings);
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();

  const links = [
    { label: t('home'), path: '/' },
    { label: t('myaccount'), path: '/bookings' },
    { label: t('about_us'), path: '/about-us' },
    { label: t('contact_us'), path: '/contact-us' },
    { label: t('privacy_policy'), path: '/privacy-policy' },
    { label: t('term_condition'), path: '/term-condition' },
  ];

  return (
    <footer className={footerClasses}>
      <div className={classes.footerAccent} aria-hidden="true" />
      <div className={classes.container} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
        <div className={isRTL === 'rtl' ? classes.right : classes.left}>
          <List className={classes.list}>
            {links.map((item) => (
              <ListItem className={classes.inlineBlock} key={item.path}>
                <a
                  className={classes.block}
                  href={item.path}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(item.path);
                  }}
                >
                  {item.label}
                </a>
              </ListItem>
            ))}
          </List>
        </div>
        {settings && settings.CompanyWebsite ? (
          <div className={classes.copyright}>
            &copy; {1900 + new Date().getYear()}{" "}
            <a
              href={settings.CompanyWebsite}
              className={aClasses}
              target="_blank"
              rel="noreferrer"
            >
              {settings.CompanyName}
            </a>
          </div>
        ) : null}
      </div>
    </footer>
  );
}

HomeFooter.propTypes = {
  whiteFont: PropTypes.bool
};
